var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadiobuttoncheckedModuleFilledTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5C6.98 2.5 2.5 6.98004 2.5 12.5001C2.5 18.0202 6.98 22.5002 12.5 22.5002C18.02 22.5002 22.5 18.0202 22.5 12.5001C22.5 6.98004 18.02 2.5 12.5 2.5ZM10.5 17.5001L5.5 12.5001L6.91 11.0901L10.5 14.6701L18.09 7.08004L19.5 8.50006L10.5 17.5001Z",
    fill: "#2DC26B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiobuttoncheckedModuleFilledTick);
export default __webpack_public_path__ + "static/media/Radio button checkedModuleFilledTick.7a7c448fcb8e7497aff3d4af187969a2.svg";
export { ForwardRef as ReactComponent };